import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

/**
 * A reusable confirmation modal component that can optionally include a date picker
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.show - Controls visibility of the modal
 * @param {Function} props.onHide - Function to call when modal is closed/hidden
 * @param {string} props.title - Title of the modal
 * @param {string} props.body - Body text of the modal
 * @param {string} props.confirmText - Text for the confirm button
 * @param {Function} props.onConfirm - Function to call when confirmed
 * @param {boolean} props.isLoading - Loading state for the confirm button
 * @param {boolean} props.requireDate - Whether to show a date picker
 * @param {string} props.dateValue - Current date value (YYYY-MM-DD format)
 * @param {Function} props.onDateChange - Function to call when date changes
 * @param {string} props.dateLabel - Label text for the date picker
 */
const ConfirmationModal = ({
  show,
  onHide,
  title,
  body,
  confirmText,
  onConfirm,
  isLoading = false,
  requireDate = false,
  dateValue = '',
  onDateChange = () => {},
  dateLabel = 'Datum',
  invoiceDate = '',
  invoiceDueDate = '',
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{body}</p>
        
        {requireDate && (
          <Form.Group controlId="confirmationDate" className="mt-3">
            <Form.Label>{dateLabel}</Form.Label>
            <Form.Control
              type="date"
              value={dateValue}
              onChange={(e) => onDateChange(e.target.value)}
              min={invoiceDate} // Prevent selecting a date prior to the invoiceDate
              required
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Avbryt
        </Button>
        <Button
          variant="success"
          onClick={onConfirm}
          disabled={isLoading || (requireDate && !dateValue)}
        >
          {isLoading ? 'Uppdaterar...' : confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;